export default ({ request }) => ({

  scmInputTemplateListApi(data) {
    return request({
      url: '/digitalCenter/scmInputTemplate/list',
      method: 'post',
      data
    })
  },
  scmInputTemplateDetailApi(data) {
    return request({
      url: '/digitalCenter/scmInputTemplate/detail',
      method: 'post',
      data
    })
  },
  scmInputTemplateSaveApi(data) {
    return request({
      url: '/digitalCenter/scmInputTemplate/save',
      method: 'post',
      data
    })
  },
  scmInputTemplateDelApi(data) {
    return request({
      url: '/digitalCenter/scmInputTemplate/del',
      method: 'post',
      data
    })
  },
// 根据供应商类别查询供应商属性输入模板接口
  scmInputTemplateSelTemByScmCategoryCodeApi(data) {
    return request({
      url: '/digitalCenter/scmInputTemplate/selTemByScmCategoryCode',
      method: 'post',
      data
    })
  }
})
